/**
 * External dependencies.
 */
import { isEmpty, has, find } from 'lodash';

/**
 * WordPress dependencies
 */

const { transformStyles } = wp.blockEditor;

/**
 * Internal dependencies.
 */
// import { getBackgroundStyle, getTextStyle, updateBlock, addStyleTag } from '../../extensions/custom-styles';

function styling( coreStyles, gutenifyStyles, isAdmin = false ) {
	const textFontFamily = has( gutenifyStyles, 'typography.fontFamilySlug' ) ? ( gutenifyStyles.typography.fontFamilySlug ) : '';
	const headingsFontFamily = has( gutenifyStyles, 'elements.headings.typography.fontFamilySlug' ) ? ( gutenifyStyles.elements.headings.typography.fontFamilySlug ) : '';
	const textColor = has( coreStyles, 'color.text' ) ? ( coreStyles.color.text ) : '';
	const backgroundColor = has( coreStyles, 'color.background' ) ? ( coreStyles.color.background ) : '';
	const h1Color = has( coreStyles, 'elements.h1.color.text' ) ? ( coreStyles.elements.h1.color.text ) : '';
	const buttonBackgroundColor = has( coreStyles, 'blocks.core/button.color.background' ) ? ( coreStyles.blocks[ 'core/button' ].color.background ) : '';
	const buttonTextColor = has( coreStyles, 'blocks.core/button.color.text' ) ? ( coreStyles.blocks[ 'core/button' ].color.text ) : '';

	const linkColor = has( coreStyles, 'elements.link.color.text' ) ? ( coreStyles.elements.link.color.text ) : '';
	const linkHoverColor = has( gutenifyStyles, 'elements.linkHover.color.text' ) ? ( gutenifyStyles.elements.linkHover.color.text ) : '';

	const buttonHoverTextColor = has( gutenifyStyles, 'blocks.core/button.hover.color.text' ) ? ( gutenifyStyles.blocks[ 'core/button' ].hover.color.text ) : '';
	const buttonHoverBackgroundColor = has( gutenifyStyles, 'blocks.core/button.hover.color.background' ) ? ( gutenifyStyles.blocks[ 'core/button' ].hover.color.background ) : '';

	let eleCss = '';
	let css = '';

	if ( textFontFamily ) {
		const predefinedFontFamily = find(
			window._gutenify.font_families,
			( { slug: f } ) => f === textFontFamily
		);
		if ( predefinedFontFamily ) {
			css += `${ isAdmin ? '.editor-styles-wrapper ' : 'body' } {
				font-family: ${ predefinedFontFamily.fontFamily };
			}`;
		}
	}

	if ( headingsFontFamily ) {
		const predefinedFontFamily = find(
			window._gutenify.font_families,
			( { slug: f } ) => f === headingsFontFamily
		);
		if ( predefinedFontFamily ) {
			eleCss = `h1,
			h2,
			h3,
			h4,
			h5,
			h6{
				font-family: ${ predefinedFontFamily.fontFamily };
			}`;

			css += transformStyles(
				[
					{
						css: eleCss,
					},
				],
				isAdmin ? '.editor-styles-wrapper' : ''
			);
		}
	}

	eleCss = `.wp-block-button .wp-block-button__link, .woocommerce #respond input#submit,
	.woocommerce a.button,
	.woocommerce button.button,
	.woocommerce input.button,
	.woocommerce #respond input#submit.alt,
	.woocommerce a.button.alt,
	.woocommerce button.button.alt,
	.woocommerce input.button.alt{
		${ buttonTextColor ? `color: ${ buttonTextColor };` : '' }
		${ buttonBackgroundColor ? `background-color: ${ buttonBackgroundColor };` : '' }
	}`;

	css += transformStyles(
		[
			{
				css: eleCss,
			},
		],
		isAdmin ? '.editor-styles-wrapper' : ''
	);

	if ( buttonBackgroundColor ) {
		eleCss = `.is-style-outline > .wp-block-button__link:not(.has-background){
			${ buttonBackgroundColor ? `background-color: transparent;` : '' }
		}`;

		const transformedStyles = transformStyles(
			[
				{
					css: eleCss,
				},
			],
			isAdmin ? '.editor-styles-wrapper' : ''
		);

		css += transformedStyles;
	}

	css += `${ isAdmin ? '.editor-styles-wrapper ' : '' } .wp-block-button.is-style-outline > .wp-block-button__link:not(.has-text-color){
		${ buttonTextColor ? `color: ${ buttonTextColor };` : '' }
	}`;

	eleCss = `.wp-block-button .wp-block-button__link.wp-block-button__link:not(.has-background):not(.has-text-color):hover, .woocommerce #respond input#submit,
	.wp-block-button.is-style-outline .wp-block-button__link.wp-block-button__link:not(.has-background):not(.has-text-color):hover,
	.woocommerce a.button:hover,
	.woocommerce button.button:hover,
	.woocommerce input.button:hover,
	.woocommerce #respond input#submit.alt:hover,
	.woocommerce a.button.alt:hover,
	.woocommerce button.button.alt:hover,
	.woocommerce input.button.alt:hover{
		${ buttonHoverTextColor ? `color: ${ buttonHoverTextColor };` : '' }
		${ buttonHoverBackgroundColor ? `background-color: ${ buttonHoverBackgroundColor };` : '' }
	}`;

	css += transformStyles(
		[
			{
				css: eleCss,
			},
		],
		isAdmin ? '.editor-styles-wrapper' : ''
	);

	// css += `${ isAdmin ? '.editor-styles-wrapper ' : '' } .wp-block-button .wp-block-button__link.wp-block-button__link:not(.has-background):not(.has-text-color):hover,
	// ${ isAdmin ? '.editor-styles-wrapper  .gutenify-button-link.wp-block-button__link.wp-block-button__link:not(.has-background):not(.has-text-color):hover,' : '' }
	// ${ isAdmin ? '.editor-styles-wrapper ' : '' } .wp-block-button.is-style-outline .wp-block-button__link.wp-block-button__link:not(.has-background):not(.has-text-color):hover{
	// 	${ buttonHoverTextColor ? `color: ${ buttonHoverTextColor };` : '' }
	// 	${ buttonHoverBackgroundColor ? `background-color: ${ buttonHoverBackgroundColor };` : '' }
	// }`;

	css += `${ isAdmin ? '.editor-styles-wrapper ' : '' } a:hover,a:active{
		${ linkHoverColor ? `color: ${ linkHoverColor };` : '' }
	}`;

	return css;
}

export default styling;
